module.exports = __webpack_public_path__ + "img/regiter-icon05-selected.e931f5c6.png";